import Game from '../game';
import Sound, { SoundParams } from './sound';
import Scene from '../scene/scene';

export interface MusicParams extends SoundParams {
  loop?: boolean;
}

export default class Music extends Sound implements MusicParams {
  loop = false;

  minTimeBeforeLoop: number | undefined = undefined; // prevent the music from being "reset" when calling the play method
  ignoreCamera = true;

  get scene(): Scene {
    return Game.instance.scene;
  }

  constructor(params: MusicParams) {
    super(params);
    this.applyParams(params);

    // if (this?.scene?.music)
    //   this.scene.music.pause();
    // if (this.scene)
    //   this.scene.music = this;
    this.minTimeBeforeLoop = undefined;
  }

  setAudio(): void {
    super.setAudio();
    this.audio.loop = this.loop;
  }

  fadeToVolume(volumeToReach = 0, duration = 1000): void // duration in milliseconds
  {
    const volumeBefore = this.volume;
    if (volumeBefore === volumeToReach)
      return;
    const frequency = 60;
    const iterationsNumber = frequency * duration / 1000;
    const volumeDiff = Math.abs(volumeToReach - this.volume);
    const interval = setInterval(() => {
      const volumeToAddOrSubstract = volumeDiff / iterationsNumber;
      const newVolume = (volumeBefore < volumeToReach)
        ? Math.min(this.volume + volumeToAddOrSubstract, volumeToReach)
        : Math.max(this.volume - volumeToAddOrSubstract, volumeToReach)
        ;
      this.volume = newVolume;
      this.setVolume(this.volume);
      if (this.volume === volumeToReach)
        clearInterval(interval);
    }, 1000 / frequency);
  }
}
